export default {
  init() {
    // JavaScript to be fired on the Why Choose Keystone page
    $(window).on('load', function(){
      $('.image-column').addClass('animate');
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/whyChooseKeystone.js